<div class="mt-big text-align-center">
  @if (title()) {
    <span class="b-2">{{ title() }}</span>
  }
</div>
<div
  [formGroup]="form"
  class="w-100 d-flex flex-wrap flex-column justify-content-flex-start mt-huge align-items-center"
>
  <div class="d-flex align-items-center justify-content-center">
    <ui-form-field
      [autoFocus]="true"
      [maxAmount]="maxAmount()"
      [minAmount]="minAmount()"
      [type]="'large-amount'"
      [maxSize]="16"
      placeholder="0"
      [formControlName]="'amount'"
      [isNumericKeyboard]="true"
      [convertNonEnglishDigits]="true"
    ></ui-form-field>
  </div>
</div>
